'use strict';

/* global productRegistration_messages, grecaptcha */

export default function() {
  // Need to wait until scripts `productRegistrationForm.jsp` are executed...
  $(window).on('load', () => {
    var $submit = $('#SubmitButton');
    var $form = $('#powf_D049F6BE0307E51180EDC4346BAC6B34');
    var $policyAccept = $('#privacyPolicyAccept');
    var $errorsContainer = $('#errors_container');
    var $unableToProcess = $('#bike_register_unable_to_process');
    var $emailOptIn = $('#emailOptIn');
    var $emailOptInValue = $('#emailOptinValue');
    var GRECAPTCHA_ACTION = 'bike_registration_submit';
    var tok_gen = window.tok_gen || {};
    $form.validate({
      rules: {
        powf_7bb97f180407e51180edc4346bac6b34: {
          required: true,
        },
        powf_de7989290407e51180edc4346bac6b34: {
          required: true,
        },
        powf_0582a1ca0407e51180edc4346bac6b34: {
          required: true,
        },
        powf_75b609f60407e51180edc4346bac6b34: {
          required: true,
        },
        powf_6cf7ba2f0507e51180edc4346bac6b34: {
          required: true,
        },
        powf_fa347c3e0507e51180edc4346bac6b34: {
          required: true,
        },
        powf_8dd23d0a0507e51180edc4346bac6b34: {
          required: true,
        },
      },
      messages: productRegistration_messages, // productRegistration_messages is defined in productRegistrationForm.jsp
      errorPlacement: function(error, element) {
        //show the alert dialog its hidden by default
        $errorsContainer.removeClass('hide');

        //add the error styles to the form field
        $(element)
          .parent()
          .parent()
          .addClass('form__item--error alert-icon-after');

        //place the error message in the alert div.
        error.appendTo($errorsContainer);
      },
      onfocusout: false,
      onkeyup: false,
      onclick: false,
    });

    if ($policyAccept.length) {
      $submit.prop('disabled', true).addClass('disabled');

      $policyAccept.on('change', function(e) {
        var accepted = e.target.checked;

        if (accepted) {
          $submit.prop('disabled', false).removeClass('disabled');
        } else {
          $submit.prop('disabled', true).addClass('disabled');
        }
      });
    }

    $submit.on('click', function(e) {
      e.preventDefault();
      if ($submit.is('[disabled]')) {
        return;
      }

      if (!$form.valid()) {
        return;
      }
      $unableToProcess.addClass('hide');
      if (tok_gen.reCaptchaTokenToggle === true) {
        validateTokenAndSubmit();
      } else {
        $emailOptIn.is(':checked') ? $emailOptInValue.val('true') : $emailOptInValue.val('false');
        $form.submit();
      }
    });
    function validateTokenAndSubmit() {
      grecaptcha.ready(function() {
        grecaptcha
          .execute(tok_gen.reCaptchaSiteKey, {
            action: GRECAPTCHA_ACTION,
          })
          .then(function(token) {
            $.ajax({
              type: 'GET',
              dataType: 'json',
              url: '/recaptcha/verify?token=' + token,
              success: tokenSuccess,
              error: tokenError,
            });
          });
      });
    }
    function tokenSuccess(data) {
      $emailOptIn.is(':checked') ? $emailOptInValue.val('true') : $emailOptInValue.val('false');
      data === true ? $form.submit() : tokenError();
    }
    function tokenError() {
      $unableToProcess.removeClass('hide');
      $('html, body').animate({
        scrollTop: $unableToProcess.offset().top - 150,
      });
      return false;
    }
  });
}
